import React, {Component} from 'react';
import {graphql} from 'react-relay';
import Measure from 'react-measure';
import CommentsWidgetList from '../../../../components/CommentsWidgetList';
import withWidgetHeaderAndFooter from '../../../../components/withWidgetHeaderAndFooter';
import withWidgetData from '../../../../components/withWidgetData';
import withReportFilterProps from '../../../../components/withReportFilterProps';
import withQueryStringProps from '../../../../components/withQueryStringProps';
import notifyPhantomWhenMounted from '../../../../components/notifyPhantomWhenMounted';

@withReportFilterProps
@withWidgetData(
  graphql`
    query CommentsWidgetQuery(
      $widgetId: ID!
      $from: String!
      $to: String!
      $deviceIds: [ID]!
      $filterComments: Boolean!
      $demoData: Boolean!
      $questionFilters: [QuestionFilterInput]
      $commentExtraColumns: [ID]
      $count: Int!
      $cursor: String
    ) {
      widget(id: $widgetId) {
        id
        name
        config {
          subtitle
          hideHeader
          hideCommentTime
          commentExtraColumns {
            title
            questionId
          }
          question {
            text {
              language
              text
            }
            answersReport(
              from: $from
              to: $to
              deviceIds: $deviceIds
              filterComments: $filterComments
              demoData: $demoData
              questionFilters: $questionFilters
            ) {
              count
            }
            ...CommentsWidgetList_question
          }
        }
      }
    }
  `,
  {
    count: 100,
  },
)
@notifyPhantomWhenMounted()
@withWidgetHeaderAndFooter()
@withQueryStringProps(['print'])
class CommentsWidget extends Component {
  constructor(props) {
    super(props);
    this.state = {
      scrolledToBottom: false,
    };
  }

  handleMeasure = ({bounds, scroll}) => {
    const distanceToBottom = scroll.height-bounds.height-scroll.top;
    if (distanceToBottom <= 100 && !this.state.scrolledToBottom) {
      this.setState({scrolledToBottom: true});
    } else if (distanceToBottom > 100 && this.state.scrolledToBottom) {
      this.setState({scrolledToBottom: false});
    }
  };

  render() {
    const listMargin = 20;
    const styles={
      listWrapper: {
        margin: `0 ${listMargin}px ${listMargin}px`,
        height: this.props.bodyHeight-20,
        overflowY: this.props.print ? 'hidden' : 'scroll',
      },
    };
    const scrollBarWidth = 17;

    const widget = this.props.widget;
    const question = widget.config.question;
    return (
      <Measure bounds scroll onResize={this.handleMeasure}>
        {({measureRef, measure}) =>
          <div
            ref={measureRef}
            style={styles.listWrapper}
            onScroll={() => measure()}
          >
            <CommentsWidgetList
              question={question}
              width={this.props.width-(listMargin*2)-scrollBarWidth}
              scrolledToBottom={this.state.scrolledToBottom}
              showTerminalColumn={this.props.deviceIds.length > 1}
              showTimeColumn={!widget.config.hideCommentTime}
              questionFilters={this.props.questionFilters && this.props.questionFilters.filter(qf => !!qf.options)}
              showLocation={this.props.report.groupByLocation}
              extraColumns={widget.config.commentExtraColumns}
            />
          </div>
        }
      </Measure>
    );
  }
}

export default CommentsWidget;



// WEBPACK FOOTER //
// ./src/components/widgetTypes/components/CommentsWidget/CommentsWidget.js